import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'charityName';

export interface FormValues {
  charityName: string | null;
}

export const validation = yup.object().shape({
  charityName: yup
    .string()
    .nullable()
    .required("Please, enter the charity's name"),
});
